import React, { memo } from 'react';
import { styled } from '@compiled/react';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import SidebarLink from '../../../../common/ui/sidebar-link';
import { messages } from './messages';

const TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';

type Props = {
	label?: string;
};

const ViewAllProjects = ({ label }: Props) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<SidebarLink
			href="/jira/projects?selectedProjectType=business"
			testId={TEST_ID}
			onClick={() =>
				fireUIAnalytics(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
			}
		>
			<Content>{label ?? formatMessage(messages.viewAllProjectsLabel)}</Content>
		</SidebarLink>
	);
};

export default memo(ViewAllProjects);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Content = styled.span({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	fontWeight: 400,
});
